import request from '@/utils/request'

const wordTypeURL = {
  Created: '/forbidden-words-type/create',
  Detail: '/forbidden-words-type/view',
  List: '/forbidden-words-type/list',
  Delete: '/forbidden-words-type/delete',
  Update: '/forbidden-words-type/update'
}

// 创建违禁词
export function createTypeWord (data) {
  return request({
    url: wordTypeURL.Created,
    method: 'post',
    data
  })
}

// 违禁词列表
export function listTypeWord (data) {
  return request({
    url: wordTypeURL.List,
    method: 'post',
    data
  })
}

// 违禁词详情
export function detaileTypeWord (data) {
  return request({
    url: wordTypeURL.Detail,
    method: 'post',
    data
  })
}

// 更新违禁词
export function updateTypeWord (data) {
  return request({
    url: wordTypeURL.Update,
    method: 'post',
    data
  })
}

// 删除违禁词
export function deleteTypeWord (data) {
  return request({
    url: wordTypeURL.Delete,
    method: 'post',
    data
  })
}

export default {
  createTypeWord,
  listTypeWord,
  detaileTypeWord,
  updateTypeWord,
  deleteTypeWord
}
